import * as React from 'react';
import { SVGProps } from 'react';

const IconAlignRightSizeS = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 16 16" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M15 3H5v2h10V3zM1 7h14v2H1V7zm4 4h10v2H5v-2z" />
  </svg>
);
export default IconAlignRightSizeS;
